




















import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { WorkerAnonModule } from '@/store/modules/workerAnon';

@Component({
  name: 'MarketingOptOut',
  components: {  }
})
export default class extends GiganautVue {
  get loading() {
    return WorkerAnonModule.loading;
  }
}
